import Enums from 'utils/EnumsManager';
import { SELECT_OBJECTTYPE, SET_HISTORY } from './actionTypes';

const { ObjectTypes } = Enums;
const { Leads } = ObjectTypes;

const initialState = {
  objectType: Leads,
  exportHistory: {
    pagination: {
      total: 0,
      count: 0,
      per_page: 20,
      current_page: 1,
      total_pages: 1,
    },
    historyData: [],
  },
};

const fileExport = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SELECT_OBJECTTYPE:
      const { objectType } = payload;
      return {
        ...state,
        objectType
      };

    case SET_HISTORY:
      const { historyData, pagination } = payload;
      return {
        ...state,
        exportHistory: {
          ...state.exportHistory,
          historyData,
          pagination
        }
      };

    default:
      return state;
  }
};

export default fileExport;



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/flow/reducer.js